import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaGraduationCap, FaCheckCircle, FaChartLine, FaBell } from 'react-icons/fa';
import '../../../../assets/css/general/footer/FeaturesDetail.css';

const StudentPortal = () => {
  return (
    <div className="feature-detail-page">
      <div className="feature-detail-container">
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>

        <div className="feature-header">
          <div className="feature-icon-large">
            <FaGraduationCap />
          </div>
          <h1 className="feature-title">Donor Portal</h1>
          <p className="feature-subtitle">
         Your personalized dashboard for supporting students and tracking your impac
          </p>
        </div>

        <div className="feature-content">
          <section className="feature-section">
            <h2>Welcome to Your Portal</h2>
            <p>
            The Donor Portal is your central hub for making a meaningful difference in students’ lives.
             From exploring verified support requests to tracking your donations and impact, 
             everything you need to contribute with confidence is right here.
            </p>
          </section>

          <section className="feature-section">
            <h2>Portal Features</h2>
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">🤝</div>
                <h3>Browse Verified Requests</h3>
                <p>Explore verified student support requests and choose causes that matter to you.</p>
              </div>
              <div className="step-card">
                <div className="step-number">💳</div>
                <h3>Secure Donations</h3>
                <p>Donate directly to verified institutions with full transparency and security.</p>
              </div>
              <div className="step-card">
                <div className="step-number">📈</div>
                <h3>Impact Tracking</h3>
                <p>Track how your contributions are helping students achieve their educational goals.</p>
              </div>
              <div className="step-card">
                <div className="step-number">💬</div>
                <h3>Student & NGO Communication</h3>
                <p>Stay connected with students and NGOs through secure and trusted messaging.</p>
              </div>
            </div>
          </section>

          <section className="feature-section">
            <h2>Key Benefits</h2>
            <div className="features-list">
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Easy Access</h4>
                  <p>Access your donor portal anytime, anywhere, from any device.</p>
                </div>
              </div>
              <div className="feature-item">
                <FaChartLine className="feature-check" />
                <div>
                  <h4>Track Your Impact</h4>
                  <p>Monitor your donations and see the real difference you’re making in students’ lives.</p>
                </div>
              </div>
              <div className="feature-item">
                <FaBell className="feature-check" />
                <div>
                  <h4>Real-time Notifications</h4>
                  <p>Get instant alerts when a student request is updated or a donation is confirmed.</p>
                </div>
              </div>
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Secure Payment Records</h4>
                  <p>Safely view and manage your donation history and payment details in one place.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="feature-section cta-section">
            <h2>Ready to Access Your Portal?</h2>
            <p>Login or register to start supporting students and making a lasting impact through your donations today.</p>
            <button className="cta-button">Access Portal</button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default StudentPortal;